import { spacing, color, borderRadius, breakpoints } from '@/theme/tokens';
import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import IconCheckCircleFilled from '@/assets/icons/IconCheckCircleFilled';

type ContractAgreementAcceptedProps = {
    successMessageText: string;
    style?: React.CSSProperties;
};

const SuccessMessage = styled(Box)`
    display: flex;
    align-items: center;
    gap: ${spacing[8]};
    padding: ${spacing[32]};
    background-color: ${color.white[0]};
    border-radius: ${borderRadius[8]};
    justify-content: center;
    margin-top: ${spacing[32]};

    @media (max-width: ${breakpoints.md}) {
        padding: ${spacing[24]};
        margin-top: ${spacing[24]};
    }

    @media (max-width: ${breakpoints.sm}) {
        padding: ${spacing[16]};
        margin-top: ${spacing[16]};
    }
`;

const ContractAgreementAccepted = ({ successMessageText, style }: ContractAgreementAcceptedProps) => {
    return (
        <SuccessMessage style={style}>
            <IconCheckCircleFilled width={24} height={24} color={color.brand[50]} />
            <Typography variant="label5semibold" color={color.brand[50]}>
                {successMessageText}
            </Typography>
        </SuccessMessage>
    );
};

export default ContractAgreementAccepted;
